import { createFeatureSelector, createSelector } from "@ngrx/store";
import { LoggedUserData } from "./logged-user.reducer";

export const selectLoggedUserData = createFeatureSelector<LoggedUserData>('loggedUser');

export const selectLoggedUserId = createSelector(selectLoggedUserData, s => s.userId);
export const selectPermissions = createSelector(selectLoggedUserData, s => s.permissions);
export const selectIsSuperAdmin = createSelector(selectLoggedUserData, s => s.isSuperAdmin);
export const selectTenantName = createSelector(selectLoggedUserData, s => s.tenantName);
export const selectImpersonation = createSelector(selectLoggedUserData, s => s.impersonation);
export const selectIsImpersonating = createSelector(selectImpersonation, i => i !== null);
